













































import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
//import iwPromotionalCode from "@/encoding/pages/questions/payment/PromotionalCode.vue"; Hiding component as per BWEB-175
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { isBillboardSelected } from "@/shared/scripts/helpers/customer/billingAddress";

export default Vue.extend({
    components: {
        //iwPromotionalCode: iwPromotionalCode Hiding component as per BWEB-175
    },

    props: {
        action: {
            type: String,
            required: false,
            default: "PUBLICATION"
        }
    },

    computed: {
        ...mapState("CustomersModule", ["currentCustomer"]),

        ...mapState("OrdersModule", [
            "currentOrder",
            "manualDiscountId"
        ]),

        ...mapGetters("OrdersModule", [
            "package",
            "visualizationKey"
        ]),

        discount: function(): string {
            if (!this.currentOrder) { return ""; }

            return this.package.automaticDiscount;
        },

        typeOfProperty: function(): string {
            if (!this.currentOrder) { return ""; }

            const { propertyType, transactionType } = this.currentOrder.tariff;

            const propertyTransKey = propertyType.toLowerCase();
            const transactionTransKey = transactionType === "FOR_SALE" ? "to_buy" : "to_rent";

            return `${this.$t(propertyTransKey)} ${this.$t(transactionTransKey)}`.toLowerCase();
        },

        duration: function(): string {
            if (!this.currentOrder) { return ""; }

            const { count, unit } = this.currentOrder.tariff.duration;
            return this.pluralization(`x_${unit.toLowerCase()}s`, count);
        },

        price: function(): string {
            return this.package?.price ?? "";
        },

        priceOfAd: function(): string {
            const price = Number(this.price || 0);
            const discountValue = Number(this.discount || 0);
            const surcharge = discountValue > 0 ? discountValue : 0;
            return this.formatCurrency((price + surcharge).toString()) + "";
        },

        priceOfBillboardRaw: function(): number {
            return this.package?.billboardPrice ?? 0;
        },

        priceOfBillboard: function(): string {
            const price = this.package?.billboardPrice ?? 0;
            return this.formatCurrency(price.toString());
        },

        // Extending an existing ad's duration never ships a new sign, so it's excluded
        // regardless of pack/price.
        //
        // While the funnel's own selection is still in the store, it's authoritative -
        // isBillboardSelected() is the exact check createOrder uses, so it correctly
        // reflects a genuine opt-out on Premium (which otherwise bundles a free sign).
        // Only fall back to the order-derived heuristic (paid sign, or free-in-Premium)
        // once that selection is gone, e.g. after a hard reload of this payment page.
        hasBillboardInOrder: function(): boolean {
            if (this.action === "EXTENSION") {
                return false;
            }

            const getTransaction = this.$store.getters["FormModule/getValueTransaction"];
            const selectionState = getTransaction("optimizedEncoding.selectedPackOptions");
            const funnelSelectionLoaded = !!selectionState && Object.keys(selectionState).length > 0;
            if (funnelSelectionLoaded) {
                return isBillboardSelected(getTransaction, this.$store.getters["FormModule/getValueOrder"]);
            }

            if (this.priceOfBillboardRaw > 0) {
                return true;
            }

            return (this.currentOrder?.visualizationOption ?? "").toLowerCase() === "premium"
                && this.currentOrder?.tariff?.transactionType === "FOR_SALE";
        },

        totalCost: function(): string {
            if (this.manualDiscountId && !this.package.totalPrice) {
                return "€...";
            }

            return this.formatCurrency(
                this.package.totalPrice ?? this.price
            );
        },
    },

    created: function() {
        if (this.currentCustomer && !("hasInvoicingEnabled" in this.currentCustomer)) {
            this.setCurrentCustomer(this.currentCustomer.id)
                .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()));
        }
    },

    methods: {
        ...mapActions("CustomersModule", ["setCurrentCustomer"])
    }
});
